import React, { useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';
import FaIconView from '../FaIconView/FaIconView';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import './filters_panel.scss';
import CountryPicker from '../CountryPicker/CountryPicker';

export interface Filtering {
  filters: {
    country: string;
    city: string;
    gender: string;
  };
  order: {
    orderBy: string;
    orderType: string;
  };
}

interface Props {
  onFiltersSubmit: (filtering: Filtering) => void;
}

const FiltersPanel: React.FC<Props> = ({ onFiltersSubmit }) => {
  const [openCollapse, setOpenCollapse] = useState(false);
  const [filters, setFilters] = useState({
    country: 'all',
    city: 'all',
    gender: 'all',
  });
  const [order, setOrder] = useState({
    orderBy: 'name',
    orderType: 'asc',
  });
  const [filtersReset, setFiltersReset] = useState(false);

  // whenever the total filters are changed just re-submit them
  useEffect(() => {
    if (filtersReset) submitFilters();
  }, [filtersReset]);

  const onFilterChange = (name: string, value: string) => {
    setFilters({ ...filters, [name]: value });
  };

  const onOrderChange = (name: string, value: string) => {
    setOrder({ ...order, [name]: value });
  };

  const resetFilters = async () => {
    setFilters({ country: 'all', city: 'all', gender: 'all' });
    setOrder({ orderBy: 'createdAt', orderType: 'desc' });

    setFiltersReset(true);
  };

  const submitFilters = () => {
    onFiltersSubmit({ filters, order });
    setFiltersReset(false);

    setOpenCollapse(false);
  };

  return (
    <div>
      <div
        className="filters-toggle-container"
        onClick={() => setOpenCollapse(!openCollapse)}
        role="button"
      >
        <FaIconView
          containerStyle="filters-toggle"
          iconStyle="filters-toggle-icon"
          label="فلترة وترتيب"
          icon={faSlidersH}
          iconSize="1x"
        />
        <FontAwesomeIcon icon={openCollapse ? 'angle-up' : 'angle-down'} />
      </div>

      <Collapse isOpened={openCollapse}>
        <div className="filters-wrapper">
          <div className="tools-container">
            <div className="bottom-space filters-container">
              <div className="legend flex-row">
                <p>فلترة حسب</p>
              </div>

              <div className="country-tools-container">
                <CountryPicker
                  showCities
                  allCountriesOption="كل البلدان"
                  allCitiesOption="كل المدن"
                  countriesLabel="البلد"
                  citiesLabel="المدينة"
                  selectedCountry={filters.country}
                  selectedCity={filters.city}
                  onCountrySelect={(val) => onFilterChange('country', val)}
                  onCitySelect={(val) => onFilterChange('city', val)}
                />
              </div>

              <div className="flex-row">
                <div className="gender-label">
                  <p>الجنس</p>
                </div>
                <div>
                  <select
                    name="gender"
                    value={filters.gender}
                    onChange={(e) => onFilterChange('gender', e.target.value)}
                  >
                    <option value="all" label="الكل" />
                    <option value="male" label="ذكر" />
                    <option value="female" label="أنثى" />
                  </select>
                </div>
              </div>
            </div>

            <div className="bottom-space order-container">
              <div className="legend flex-row">
                <p>ترتيب حسب</p>
              </div>
              <div className="flex-row">
                <select
                  className="order-list"
                  name="orderBy"
                  value={order.orderBy}
                  onChange={(e) => onOrderChange('orderBy', e.target.value)}
                >
                  <option value="name" label="الاسم" />
                  <option value="createdAt" label="تاريخ الانضمام" />
                  <option value="likes" label="الإعجابات" />
                  <option value="views" label="المشاهدات" />
                  <option value="age" label="العمر" />
                </select>

                <div className="flex-row">
                  <div>
                    <span className="order-radio-container">
                      <label>
                        <input
                          className="order-radio"
                          type="radio"
                          value="asc"
                          name="orderType"
                          checked={order.orderType === 'asc'}
                          onChange={(e) =>
                            onOrderChange('orderType', e.target.value)
                          }
                        />
                        تصاعدياً
                      </label>
                    </span>
                    <span className="order-radio-container">
                      <label>
                        <input
                          className="order-radio"
                          type="radio"
                          value="desc"
                          name="orderType"
                          checked={order.orderType === 'desc'}
                          onChange={(e) =>
                            onOrderChange('orderType', e.target.value)
                          }
                        />
                        تنازلياً
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="buttons-wrapper flex-row">
            <button className="apply-button" onClick={submitFilters}>تطبيق الفلاتر</button>
            <button className="reset-button" onClick={resetFilters}>مسح الفلاتر</button>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default FiltersPanel;
